'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = require('decisiv-ui-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = function styles(_ref) {
  var theme = _ref.theme;
  return '\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0 0 0 ' + (0, _decisivUiUtils.px2rem)(5) + ';\n\n  &:hover, &:focus {\n    span.fa {\n      color: ' + theme.colors.status.danger + ';\n    }\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    status: _propTypes2.default.shape({
      danger: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

var propTypes = {
  onClick: _propTypes2.default.func.isRequired
};

var CloseButton = (0, _decisivUiUtils.buildStyledComponent)('CloseButton', _styledComponents2.default.button, styles, {
  themePropTypes: themePropTypes,
  propTypes: propTypes
});

exports.default = CloseButton;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/blocks/Tag/CloseButton.js
// module id = 1612
// module chunks = 2